<template>
  <div class="container">
    <div class="common-header-wrap">
      <!-- <mt-header :title="$t('Promotion member')" class="common-header"> -->
      <mt-header :title="$t('MyTeam')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        <mt-button slot="right" @click="openPicker">{{ $t('Data') }}</mt-button>
      </mt-header>
    </div>

    <div class="search">
      <input type="text" v-model="value" :placeholder="$t('Search')" @keyup.enter="handleEnter" />
      <div class="search1 ds-button" @click="handleEnter">Search</div>
    </div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="list" v-if="userList && userList.length">
        <div class="item" v-for="(item, index) in userList" :key="index">

          <div class="sn-date flex">
            <div class="sn"> {{ item.member_name }}</div>
            <div class="date">{{ item.member_addtime }}</div>
            <div class="search1 ds-button" @click="gotoSearch(item)">Search</div>
          </div>

        </div>
      </div>
      <empty-record v-else-if="userList && !userList.length"></empty-record>
    </div>

    <mt-datetime-picker ref="picker" type="date" :cancelText="$t('MessageBox.Cancel')"
      :confirmText="$t('MessageBox.Confirm')" v-model="pickerValue" :endDate="endDate_" @confirm="changeTime"
      @touchmove.native.stop.prevent>
    </mt-datetime-picker>
  </div>
</template>

<script>
import { getInviterUser, getInviterUserChild } from '../../../api/memberInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'MemberInviterUser',
  components: {
    EmptyRecord
  },
  data() {
    return {
      params: {
        'page': 0,
        'per_page': 10,
        // 'date': this.utils.formatDate_(new Date),
        'date': '',
        member_name: ''
      },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      userList: false,
      type: this.$route.query.type ? this.$route.query.type : 0,
      pickerValue: '',
      endDate: '',
      endDate_: new Date(),
      value: '',
    }
  },
  created() {

  },

  mounted() {

  },
  methods: {
    gotoSearch(item) {
      this.$router.push({ name: 'MemberSearchGiftList', query: { tmember_id: item.member_id } })
    },
    handleEnter() {
      // if (!this.value) return
      this.params.member_name = this.value
      this.getUserList(false)
    },
    getUserList(ispush) {
      Indicator.open()
      let params = this.params
      if (this.type == 1) {
        getInviterUserChild(params).then(res => {
          Indicator.close()
          if (res) {
            if (ispush && this.userList) {
              this.userList = this.userList.concat(res.result.list)
            } else {
              this.userList = res.result.list
            }
            if (res.result.hasmore) {
              this.isMore = true
            } else {
              this.isMore = false
            }
          }
        })
      } else {
        getInviterUser(params).then(res => {
          Indicator.close()
          if (res) {
            if (ispush && this.userList) {
              this.userList = this.userList.concat(res.result.list)
            } else {
              this.userList = res.result.list
            }
            if (res.result.hasmore) {
              this.isMore = true
            } else {
              this.isMore = false
            }
          }
        })
      }
    },
    loadMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getUserList(true)
      }
    },
    //打开时间选择器
    openPicker() {// 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
      if (this.endDate) {
        this.pickerValue = this.endDate
      } else {
        this.pickerValue = new Date()
      }

      this.$refs.picker.open()
    },
    //时间选择器选中
    changeTime(value) {
      console.log(this.utils.formatDate_(value, 'yyyy-MM-dd'));		//自带的value就是选中的时间
      let date = this.utils.formatDate_(value, 'yyyy-MM-dd')
      this.params.date = date
      this.userList = []
      this.getUserList(true)

      this.endDate = value
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #fff;
  
}

.search {
  margin: .5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .search1 {
    background: #fa2a31;
    border-radius: 10px;
    color: #FFFFFF;
    padding: 0 10px;
    font-size: .6rem;
    height: 1.6rem;
    line-height: 1.6rem;
    margin-left: 10px;
  }

  input {
    box-sizing: border-box;
    width: 100%;
    height: 1.6rem;
    border-radius: 10px;
    background-size: 0.55rem;
    font-size: 0.6rem;
    color: #999;
    background: #f4f4f4;
    padding-left: 1.6rem;
    border: 0;
  }
}

.inviter-item {
  display: flex;
  align-items: center;
  padding: .5rem;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;

  .avatar {
    width: 4.5rem;

    img {
      width: 4rem
    }
  }

  .inviter {
    flex: 1;
    font-size: $subFontSize;

    .users {
      font-size: $h3;
      // margin-bottom: 1rem;
      // margin-top: .5rem
    }

    .time {
      color: gray;
      margin-top: .2rem
    }
  }
}

.list {
  margin: 20px;
  padding: 0 22px;
  border-radius: 20px;
  border: 1px solid #707070;
  font-size: .8rem;

  .item {
    padding: 20px 0;
    border-bottom: 1px solid #bbbbbb;

    &:last-child {
      border-bottom: none;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }

    .sn {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .date {
      font-size: .6rem;
      color: #8d839c;
      text-align: right;
    }

    .search1 {
      grid-column-start: span 2;
      margin: 10px 0 0;
      text-align: center;
      background: #A62C22;
      border-radius: 10px 10px 10px 10px;
      color: #FFFFFF;
      padding: 10px;
    }
  }
}</style>
